import React from "react";
import { HomeTemplate } from "../../../components/templates";

function Home() {
  return <HomeTemplate />;
}

export default Home;
